<div [formGroup]="form" *ngIf="form">

  <div class="custom-card-title" title="Codes à renseigner">Import des fournisseurs</div>
  <div class="custom-card-body">
    <div class="dialog-line">
      <div class="dialog-line">
        <div class="label" title="Secteurs par défauts">Secteurs</div>
        <div class="value">
          <yo-tagbox
            [data]="secteurList"
            [selectedItems]="selectedSecteurs"
            (onValueChange)="onSelectedSecteursChange($event)"
            [disabled]="!canModify">
          </yo-tagbox>
        </div>
      </div>
      <div class="dialog-line"></div>
    </div>
  </div>

  <div class="custom-card-title" title="Codes à renseigner">Import des denrées</div>
  <div class="custom-card-body">
    <div class="dialog-line">
      <div class="dialog-line">
        <div class="label" title="UT de la denrée">UT</div>
        <div class="value">
          <dx-text-box
            class="inputfield"
            formControlName="codeUTDenree"
            [disabled]="!canModify">
          </dx-text-box>
        </div>
      </div>
      <div class="dialog-line">
        <div class="label" title="Type Produit de la denrée">Type Produit</div>
        <div class="value">
          <dx-text-box
            class="inputfield"
            formControlName="codeTypeProduitDenree"
            [disabled]="!canModify">
          </dx-text-box>
        </div>
      </div>
    </div>

    <div class="dialog-line">
      <div class="dialog-line">
        <div class="label" title="Zone Stockage de la denrée">Zone Stockage</div>
        <div class="value">
          <dx-text-box
            class="inputfield"
            formControlName="codeZoneStockageDenree"
            [disabled]="!canModify">
          </dx-text-box>
        </div>
      </div>
      <div class="dialog-line">
        <div class="label" title="Type Appro de la denrée">Type Appro</div>
        <div class="value">
          <dx-text-box
            class="inputfield"
            formControlName="codeTypeApproDenree"
            [disabled]="!canModify">
          </dx-text-box>
        </div>
      </div>
    </div>

    <div class="dialog-line">
      <div class="dialog-line">
        <div class="label" title="Type Sortie de la denrée">Type Sortie</div>
        <div class="value">
          <dx-text-box
            class="inputfield"
            formControlName="codeTypeSortieDenree"
            [disabled]="!canModify">
          </dx-text-box>
        </div>
      </div>
      <div class="dialog-line">
        <div class="label" title="Famille de la denrée">Famille</div>
        <div class="value">
          <dx-text-box
            class="inputfield"
            formControlName="codeFamilleDenree"
            [disabled]="!canModify">
          </dx-text-box>
        </div>
      </div>
    </div>
  </div>

  <div class="custom-card-title" title="Codes à renseigner">Import des denrées déclinées</div>
  <div class="custom-card-body">
    <div class="dialog-line">
      <div class="dialog-line">
        <div class="label" title="UT de la denrée déclinée">UT</div>
        <div class="value">
          <dx-text-box
            class="inputfield"
            formControlName="codeUTDenreeDeclinee"
            [disabled]="!canModify">
          </dx-text-box>
        </div>
      </div>
      <div class="dialog-line">
        <div class="label" title="Type Produit de la denrée déclinée">Type Produit</div>
        <div class="value">
          <dx-text-box
            class="inputfield"
            formControlName="codeTypeProduitDenreeDeclinee"
            [disabled]="!canModify">
          </dx-text-box>
        </div>
      </div>
    </div>

    <div class="dialog-line">
      <div class="dialog-line">
        <div class="label" title="Zone Stockage de la denrée déclinée">Zone Stockage</div>
        <div class="value">
          <dx-text-box
            class="inputfield"
            formControlName="codeZoneStockageDenreeDeclinee"
            [disabled]="!canModify">
          </dx-text-box>
        </div>
      </div>
      <div class="dialog-line">
        <div class="label" title="Type Appro de la denrée déclinée">Type Appro</div>
        <div class="value">
          <dx-text-box
            class="inputfield"
            formControlName="codeTypeApproDenreeDeclinee"
            [disabled]="!canModify">
          </dx-text-box>
        </div>
      </div>
    </div>

    <div class="dialog-line">
      <div class="dialog-line">
        <div class="label" title="Type Sortie de la denrée déclinée">Type Sortie</div>
        <div class="value">
          <dx-text-box
            class="inputfield"
            formControlName="codeTypeSortieDenreeDeclinee"
            [disabled]="!canModify">
          </dx-text-box>
        </div>
      </div>
      <div class="dialog-line">
        <div class="label" title="Déclinaison de la denrée déclinée">Déclinaison</div>
        <div class="value">
          <dx-text-box
            class="inputfield"
            formControlName="codeDeclinaisonDenreeDeclinee"
            [disabled]="!canModify">
          </dx-text-box>
        </div>
      </div>
    </div>
  </div>

  <div class="custom-card-title" title="Codes à renseigner">Import des articles</div>
  <div class="custom-card-body">
    <div class="dialog-line">
      <div class="dialog-line">
        <div class="label" title="Unité de commande de l'article">Unite Commande</div>
        <div class="value">
          <dx-text-box
            class="inputfield"
            formControlName="codeUniteCommandeArticle"
            [disabled]="!canModify">
          </dx-text-box>
        </div>
      </div>
      <div class="dialog-line">
        <div class="label" title="Unité de facturation de l'article">Unite Facturation</div>
        <div class="value">
          <dx-text-box
            class="inputfield"
            formControlName="codeUniteFacturationArticle"
            [disabled]="!canModify">
          </dx-text-box>
        </div>
      </div>
    </div>

    <div class="dialog-line">
      <div class="dialog-line">
        <div class="label" title="Unité de stockage de l'article">Unite Stockage</div>
        <div class="value">
          <dx-text-box
            class="inputfield"
            formControlName="codeUniteStockageArticle"
            [disabled]="!canModify">
          </dx-text-box>
        </div>
      </div>
      <div class="dialog-line">
        <div class="label" title="Allergene de l'article">Allergene</div>
        <div class="value">
          <dx-text-box
            class="inputfield"
            formControlName="codeAllergene"
            [disabled]="!canModify">
          </dx-text-box>
        </div>
      </div>
    </div>
  </div>

  <div class="custom-card-title" title="Codes à renseigner">Export des commandes</div>
  <div class="custom-card-body">
    <div class="dialog-line">
      <div class="dialog-line">
        <div class="label" title="UF Magasin">UF Magasin</div>
        <div class="value">
          <dx-text-box
            class="inputfield"
            formControlName="codeUFMagasin"
            [disabled]="!canModify">
          </dx-text-box>
        </div>
      </div>
      <div class="dialog-line">
        <div class="label" title="UF Cuisine">UF Cuisine</div>
        <div class="value">
          <dx-text-box
            class="inputfield"
            formControlName="codeUFCuisine"
            [disabled]="!canModify">
          </dx-text-box>
        </div>
      </div>
    </div>

    <div class="dialog-line">
      <div class="dialog-line">
        <div class="label" title="Code Chorus">Code Chorus</div>
        <div class="value">
          <dx-text-box
            class="inputfield"
            formControlName="codeChorus"
            [disabled]="!canModify">
          </dx-text-box>
        </div>
      </div>
      <div class="dialog-line"></div>
    </div>
  </div>

  <div class="custom-card-title" title="Codes à renseigner">Export des réceptions</div>
  <div class="custom-card-body">
    <div class="dialog-line">
      <div class="dialog-line">
        <div class="label" title="UF Magasin">UF Magasin</div>
        <div class="value">
          <dx-text-box
            class="inputfield"
            formControlName="codeUFMagasinReceptions"
            [disabled]="!canModify">
          </dx-text-box>
        </div>
      </div>
      <div class="dialog-line">
        <div class="label" title="UF Cuisine">UF Cuisine</div>
        <div class="value">
          <dx-text-box
            class="inputfield"
            formControlName="codeUFCuisineReceptions"
            [disabled]="!canModify">
          </dx-text-box>
        </div>
      </div>
    </div>
  </div>

  <div class="custom-card-title" title="Codes à renseigner">Export des sorties</div>
  <div class="custom-card-body">
    <div class="dialog-line">
      <div class="dialog-line">
        <div class="label" title="UF Magasin">UF Magasin</div>
        <div class="value">
          <dx-text-box
            class="inputfield"
            formControlName="codeUFMagasinSorties"
            [disabled]="!canModify">
          </dx-text-box>
        </div>
      </div>
      <div class="dialog-line">
        <div class="label" title="UF Cuisine">UF Cuisine</div>
        <div class="value">
          <dx-text-box
            class="inputfield"
            formControlName="codeUFCuisineSorties"
            [disabled]="!canModify">
          </dx-text-box>
        </div>
      </div>
    </div>
  </div>

  <div class="custom-card-title" title="Codes à renseigner">Export des inventaires</div>
  <div class="custom-card-body">
    <div class="dialog-line">
      <div class="dialog-line">
        <div class="label" title="UF Magasin">UF Magasin</div>
        <div class="value">
          <dx-text-box
            class="inputfield"
            formControlName="codeUFMagasinInventaires"
            [disabled]="!canModify">
          </dx-text-box>
        </div>
      </div>
      <div class="dialog-line">
        <div class="label" title="UF Cuisine">UF Cuisine</div>
        <div class="value">
          <dx-text-box
            class="inputfield"
            formControlName="codeUFCuisineInventaires"
            [disabled]="!canModify">
          </dx-text-box>
        </div>
      </div>
    </div>

    <div class="dialog-line">
      <div class="dialog-line">
        <div class="label" title="Code UF">Code UF</div>
        <div class="value">
          <dx-text-box
            class="inputfield"
            formControlName="codeUfInventaires"
            [disabled]="!canModify">
          </dx-text-box>
        </div>
      </div>
      <div class="dialog-line"></div>
    </div>
  </div>

  <div class="custom-card-title" title="Codes à renseigner">Export des factures externes</div>
  <div class="custom-card-body">
    <div class="dialog-line">
      <div class="dialog-line">
        <div class="label" title="Statuts des factures externes à exporter">Statuts à exporter</div>
        <div class="value">
          <yo-tagbox
            [data]="statutFactureExterneList"
            [selectedItems]="selectedStatutFactureExterneList"
            key="code"
            displayValue="libelle"
            (onValueChange)="onSelectedStatutFactureExterneListChange($event)"
            [disabled]="!canModify">
          </yo-tagbox>
        </div>
      </div>
      <div class="dialog-line"></div>
    </div>
  </div>

  <div class="custom-card-title" title="Codes à renseigner">Export des avoirs externes</div>
  <div class="custom-card-body">
    <div class="dialog-line">
      <div class="dialog-line">
        <div class="label" title="Statuts des avoirs externes à exporter">Statuts à exporter</div>
        <div class="value">
          <yo-tagbox
            [data]="statutAvoirExterneList"
            [selectedItems]="selectedStatutAvoirExterneList"
            key="code"
            displayValue="libelle"
            (onValueChange)="onSelectedStatutAvoirExterneListChange($event)"
            [disabled]="!canModify">
          </yo-tagbox>
        </div>
      </div>
      <div class="dialog-line"></div>
    </div>
  </div>

  <div class="custom-card-title" title="Codes à renseigner">Import des points de facturation</div>
  <div class="custom-card-body">
    <div class="dialog-line">
      <div class="dialog-line">
        <div class="label" title="Délai de paiement par défaut">Délai paiement</div>
        <div class="value">
          <dx-number-box
            class="inputfield"
            formControlName="delaiPaiementPointFacturation"
            [min]="0"
            [disabled]="!canModify">
          </dx-number-box>
        </div>
      </div>
      <div class="dialog-line">
        <div class="label" title="Point de facturation synthétique">Synthétique</div>
        <div class="value">
          <dx-check-box
            formControlName="synthetiquePointFacturation"
            [disabled]="!canModify">
          </dx-check-box>
        </div>
      </div>
    </div>
  </div>

  <div class="custom-card-title" title="Codes à renseigner">Import des sites</div>
  <div class="custom-card-body">
    <div class="dialog-line">
      <div class="dialog-line">
        <div class="label" title="Environnement par défaut">Environnement</div>
        <div class="value">
          <yo-lookup
            #environnementLookup
            [data]="environnementList"
            [selectedItem]="idSelectedEnvironnement"
            autoSelect="false"
            (onValueChange)="onChangeEnvironnement($event)"
            [disabled]="!canModify">
          </yo-lookup>
        </div>
      </div>
      <div class="dialog-line"></div>
    </div>
  </div>

  <div class="custom-card-title" title="Codes à renseigner">Import des éléments facturables</div>
  <div class="custom-card-body">
    <div class="dialog-line">
      <div class="dialog-line">
        <div class="label" title="Code taxe par défaut">Taxe</div>
        <div class="value">
          <dx-text-box
            class="inputfield"
            formControlName="codeTaxeElementFacturable"
            [disabled]="!canModify">
          </dx-text-box>
        </div>
      </div>
      <div class="dialog-line"></div>
    </div>
  </div>

  <div class="custom-card-title" title="Codes à renseigner">Import des frais fixes</div>
  <div class="custom-card-body">
    <div class="dialog-line">
      <div class="dialog-line">
        <div class="label" title="Code taxe par défaut">Taxe</div>
        <div class="value">
          <dx-text-box
            class="inputfield"
            formControlName="codeTaxeFraisFixe"
            [disabled]="!canModify">
          </dx-text-box>
        </div>
      </div>
      <div class="dialog-line"></div>
    </div>
  </div>

</div>
